import { Textarea } from '@mantine/core';
import React, { FC } from 'react';

import { useDesignField } from './hooks';

interface TextareaFieldProps {
  valuePath: Array<string>;
}

export const TextareaField: FC<TextareaFieldProps> = ({ valuePath }) => {
  const { value, onChange } = useDesignField(valuePath);

  return (
    <Textarea
      label="Tagline"
      placeholder="Supercharging your HaaS business"
      value={value ?? ''}
      onChange={(event) => onChange(event.target.value)}
    />
  );
};
